/**
 * @desc  获取state当中的状态
 * 实时监听state值的变化(最新状态) 使用方法：  this.$store.getters.aaa
 * 类 computed 计算属性，实时获取state中的数据
 */
export const get_user_info = state => state.user_info;
export const get_is_login = state => state.isLogin;
export const get_token = state => state.token;
export const get_suitid = state => state.suitid;


// WEBPACK FOOTER //
// ./src/store/getters.js